import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function CTAButton({
  children,
  className = '',
  onClick,
  href
}: CTAButtonProps) {
  const handleClick = () => {
    if (href) {
      if (href.startsWith('http')) {
        window.open(href, '_blank', 'noopener,noreferrer');
      } else {
        const el = document.querySelector(href);
        if (el) {
          el.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    }
    onClick?.();
  };
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} onClick={handleClick} className={`relative group overflow-hidden rounded-xl bg-gradient-to-r from-cyan-accent to-electric px-8 py-5 font-bold text-white transition-all animate-pulse-glow ${className}`} data-id="element-154">
      <span className="relative z-10 text-lg md:text-xl tracking-wide uppercase" data-id="element-155">
        {children}
      </span>
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-156" />
    </motion.button>;
}